<template>
    <div>

        <el-form label-position="top">

            <el-tabs type="border-card" v-model="tabAtivo">
                <el-tab-pane label="FILTROS" name="filtros">

                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="18" :md="18">
                                <el-form-item label="Instituição" key="instituicao" v-if="([4, 5, 6, 7, 8, 10, 11].includes(Number($store.state.user.tipo)))">
                                    <el-select @change="getTurmas()" ref="instituicao_id" v-model="filtro.instituicao_id" filterable placeholder="Pesquisar Instituição" clearable>
                                        <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"> </el-option>
                                    </el-select>
                                </el-form-item>
                                <div class="style-form" v-if="[0, 1, 3, 9, 12].includes(Number(this.$store.state.user.tipo))">
                                    <label>Instituição</label>
                                    <div class="style-input readonly">{{ $store.state.config.instituicao.nome }}</div>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="6" :md="6">
                                <el-form-item label="Período" key="periodo">
                                    <el-select @change="getTurmas()" ref="periodo_letivo_id" v-model="filtro.periodo_letivo_id" clearable>
                                        <el-option v-for="(item, i) in $store.state.periodos" :key="i" :label="'Periodo Letivo ' + item.nome" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>                        
                        </el-row>
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="6" :md="6">
                                <el-form-item label="Período" key="periodo">
                                    <el-date-picker
                                        style="width: 100%; margin-top: 2px;"
                                        v-model="filtro.periodo"
                                        format="M/yyyy"
                                        value-format="yyyy-M"
                                        type="monthrange"
                                        range-separator="a"
                                        start-placeholder="Início"
                                        end-placeholder="Fim">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="18" :md="18">
                                <el-form-item label="Turma" key="turma">
                                    <el-select v-model="filtro.turma_id" clearable multiple>
                                        <el-option-group
                                            v-for="(grupo, i) in turmas"
                                            :key="i"
                                            label="">
                                        <el-option
                                            v-for="turma in grupo"
                                            :key="turma.id"
                                            :label="`${turma.curso.nome} ${turma.nome}`"
                                            :value="turma.id">
                                        </el-option>
                                        </el-option-group>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>                        
                </el-tab-pane>                
            </el-tabs>

            <div class="u-mt-10">
                <el-row>
                    <el-col :xs="24" :sm="24" :md="24" class="u-text-right">
                        <el-button @click="renderRelatorioFrequenciaObs('excel')" :loading="loadingButtonExcel" type="primary">EXCEL</el-button>
                        <el-button @click="renderRelatorioFrequenciaObs('pdf')" :loading="loadingButtonPdf" type="primary">PDF</el-button>
                        <el-button @click="renderRelatorioFrequenciaObs('html')" :loading="loadingButtonHtml" type="primary">HTML</el-button>
                    </el-col>
                </el-row>
            </div>
        </el-form>

    </div>
</template>
<script>
import cPanel from '../../../shared/c-panel/c-panel.vue';

export default {
  components: { cPanel },
    data: () => ({
        tabAtivo: 'filtros',
        loadingButtonExcel: false,
        loadingButtonPdf: false,
        loadingButtonHtml: false,
        statusList: true,
        ref: [],
        filtro: {
            instituicao_id: '',
            periodo_letivo_id: '',
            turma_id: [],
            periodo: [],
        },
        paginate: {
            page: 1,
            qtdItens: null,
            from: '',
            to: ''
        },
        itens: [ ],
        turmas: []

    }),
    mounted () {

        this.filtro.periodo_letivo_id = this.$store.state.config.parametros.periodo_letivo_situacao_academica;

        if([0, 1, 3, 9, 12].includes(Number(this.$store.state.user.tipo))){

            this.filtro.instituicao_id = this.$store.state.config.instituicao.id;
        }

        this.getTurmas();
    },
    methods: {

        getTurmas(){

            if(!this.filtro.instituicao_id || !this.filtro.periodo_letivo_id){
                this.filtro.turma_id = [];
                return false;
            }

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/turma/getTurmasForListDiario/` + this.filtro.instituicao_id + '/' + this.filtro.periodo_letivo_id, this.$store.getters.getHeaderAuth).then(response => {

                this.turmas = response.data;

            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

        },
        renderRelatorioFrequenciaObs(tipo){                

            if(tipo == 'pdf'){

                this.loadingButtonPdf = true;
                this.renderPdfRelatorioGeralTurma();

            }else if(tipo == 'html'){

                this.loadingButtonHtml = true;
                this.renderHtmlRelatorioGeralTurma();

            }else if(tipo == 'excel'){

                this.loadingButtonExcel = true;
                this.renderExcelRelatorioGeralTurma();
            }
        },
        renderPdfRelatorioGeralTurma(){

            window.eventBus.$emit('print', {url: '/api/pdf/renderRelatorioFrequenciaObs/pdf', param: {ref: this.ref, filtros: this.filtro, campos: this.campos}});
            this.loadingButtonPdf = false;
        },
        renderExcelRelatorioGeralTurma(){

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/pdf/renderRelatorioFrequenciaObs/excel`, { param: {ref: this.ref, filtros: this.filtro, campos: this.campos} }, this.$store.getters.getHeaderAuthExcel).then(response => {

                this.loadingButtonExcel = false;

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'relatorio.xlsx');
                document.body.appendChild(link);
                link.click();

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        async renderHtmlRelatorioGeralTurma(){

            try{

                let response = await this.getCodAutorizacaoRelatorioHtml();

                window.open(`${process.env.VUE_APP_BASE_URL}/api/relatorio/open/${response.data.token}`);

                this.loadingButtonHtml = false;

            }catch(e){

                window.eventBus.$emit('alert', {msg: 'Erro ao gerar relatório.', type: 'warning'});
            }

        },
        getCodAutorizacaoRelatorioHtml(){

            return this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/relatorio/generateCodAutorizacaoPrintHtml/frequencia-observacao`, {ref: this.ref, filtros: this.filtro, campos: this.campos}, this.$store.getters.getHeaderAuth);
        },
        formatData(field, size = null){

            //TRATA OS INPUTS - LETRA MAIÚCULA

            if(!this.filtro[field])
                return false;

            if(size && this.filtro[field].length < size)
                this.filtro[field] = '';

            this.filtro[field] = this.filtro[field].toUpperCase();

            this.filtro[field] = this.$removerAcentos(this.filtro[field]);
        }
    }
}
</script>